export const GET_FULL_NAME_FROM_BATCH = "GET_FULL_NAME_FROM_BATCH";

//Student Notifications

export const GET_ANNOUNCEMNTS_TYPE_NOTIFICATION = "GET_ANNOUNCEMNTS_TYPE_NOTIFICATION"
//end